/**
 * [INPUT]: 依赖原生 input、共享 32px 控件尺寸/controlSurface 与 @/zinnercms-design-system/lib/utils 的 cn
 * [OUTPUT]: 对外提供 Input 组件
 * [POS]: zinnercms-design-system/ui 的单行输入真相源，原生语义避免第三方 surface 泄漏并保持旧调用形状
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { cn } from "@/zinnercms-design-system/lib/utils"
import { controlSizes, controlSurface } from "@/zinnercms-design-system/ui/foundations"

function Input({
  className,
  type,
  ...props
}) {
  return (
    <input
      type={type}
      data-slot="input"
      aria-label={props["aria-label"] ?? (props["aria-labelledby"] ? undefined : props.placeholder ?? "input")}
      className={cn(
        controlSurface,
        controlSizes.default,
        "w-full min-w-0 px-3 py-1.5 text-[13px] placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "file:mr-2 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-xs file:font-medium file:text-foreground",
        className
      )}
      {...props} />
  );
}

export { Input }
